const en = {
    translation: {
        Welcome: "Welcome",
        LoggedIn: "You are logged in.✅",
        NotLoggedIn: "You are not logged in.❌",
        Login: "Login",
        Logout: "Logout",
        Home: "Home",
        en: "English",
        al: "Albanian (Shqip)",
        SigningIn: "Signing in...",
        RedirectToLogin: "Redirecting to login...",
        LoggingOut: "Logging out...",
        PleaseLoginToMenu: "Please log in to see the menu",
        PageNotFoundRedirect: "Page not found. Redirecting...",
        Page: "Page",
        Next: "Next",
        Previous: "Previous",
        Services: "Services",
        ServiceList: "Service List",
        Loading: "Loading...",
        Back: "Back",
        Create: "Create",
        Edit: "Edit",
        Details: "Details",
        Update: "Update",
        Delete: "Delete",
        PasswordResetType: "Password Reset",
        PasswordResetMessage: "Password was reset successfully",
        OtpAssignedType: "OTP Assigned",
        OtpAssignedMessage: "OTP app was assigned successfully",
        OtpResetType: "OTP Reset",
        OtpResetMessage: "OTP app was reset successfully",
        Cancel: "Cancel",
        Actions: "Actions",
        ProfileTypes: "Profile Types",
        Save: "Save",
        ClaimList: "Claim List",
        PleaseUploadLibraryFile: "Please upload the main library file.",
        TransactionRouteIdMissing: "TransactionRoute ID not found in URL.",
        LibraryUploadSuccess: "Library uploaded successfully!",
        LibraryUploadFailure: "Upload failed.",
        UploadLibrary: "Upload Library",
        MainLibraryFile: "Main Library File",
        LibraryPath: "Library Path",
        Dependencies: "Dependencies",
        SelectedFiles: "Selected Files",
        Template: "Template",
        RemoveFile: "Remove file",
        TransactionRoutes: "Transaction Routes",
        Upload: "Upload",
        Add: "Add",
        Name: "Name",
        Search: "Search",
        Reset: "Reset",
        Select: "Select",
        Library: "Library",
        Libraries: "Libraries",
        LibrariesLinkedToTransactionRoute: "Libraries linked to Transaction Route",
        NoLibrariesFound: "No libraries found.",
        ConfirmRemoveLibrary: "Are you sure you want to remove the library '{{name}}' from this transaction route?",
        LibraryAssociationDeleted: "Library association deleted!",
        CouldNotFetchLibraryContents: "Could not fetch library contents.",
        DeleteFailedWithStatus: "Delete failed. Status {{status}}",
        ConnectionError: "Connection error: {{error}}",
        GeneralError: "Error: {{error}}",
        AddLibrariesToTransactionRoute: "Add Libraries to Transaction Route",
        LibrariesSuccessfullyAdded: "Libraries successfully added.",
        CouldNotFetchSyncStatus: "Could not fetch sync status.",
        SyncStatus: "Sync Status",
        SyncStatusFor: "Sync Status for {{libraryPath}}",
        DatabaseSyncStatus: "Database Sync Status",
        AllFilesInSync: "All files are in sync.",
        DiscrepanciesFound: "Discrepancies found.",
        MissingInTransformation: "Missing in Transformation",
        ExtraInTransformation: "Extra in Transformation",
        HashMismatches: "Hash mismatches",
        PrimarySite: "Primary Site",
        AllFilesPresent: "All files are present.",
        MissingFiles: "Missing files",
        SyncPrimary: "Sync Primary",
        BccSite: "BCC Site",
        SyncBcc: "Sync BCC",
        Sync: "Sync",
        SyncTriggered: "Sync triggered successfully.",
        SyncFailed: "Sync failed.",
        SyncFromFileSystem: "Sync from filesystem",
        SyncFromFileSystemHint: "Use the files already present in Transformations filesystem to repopulate the databases.",
        SyncFromFileSystemTriggered: "Filesystem sync started.",
        SyncFromFileSystemFailed: "Filesystem sync failed.",
        SyncDatabasesOnly: "Sync databases",
        SyncDatabasesTriggered: "Database sync started.",
        SyncDatabasesFailed: "Database sync failed.",
        NoDataAvailable: "No data available.",
        Close: "Close",
        LibraryContents: "Library Contents",
        NoLibrariesAvailable: "No libraries available.",
        AddSelectedLibraries: "Add Selected Libraries",
        AddLibraries: "Add Libraries",
        AreYouSureRemoveLibrary: "Are you sure you want to remove the library '{{name}}'?",
        AddExistingLibrary: "Add existing library",
        CouldNotFetchClassName: "Could not fetch ClassName for transactionId: {{id}}",
        CouldNotFetchServiceName: "Could not fetch Name for serviceId: {{id}}",
        UploadSuccess: "Files uploaded successfully!",
        UploadError: "Failed to update library.",
        BadRequest: "Invalid request: {{error}}",
        ServiceDeleteSuccess: "Service deleted successfully!",
        ErrorWithError: "An error occurred: {{error}}",
        StatusCode: "Status code: {{code}}",
        LibraryPathRequired: "Library path is required.",
        LibraryUpdated: "Library updated successfully!",
        MainLibraryFileRequired: "Main library file is required.",
        LibraryPathCannotContainSpaces: "Library path cannot contain spaces.",
        LibraryPathCannotStartOrEndWithSlash: "Library path cannot start or end with slash (/) or backslash (\\).",
        LibraryPathNoSpecialChars: "Library path cannot contain special characters.",
        NameExists: "Name already exists",
        CodeExists: "Code already exists",
        InLibEditAllowed: "Editing in library allowed",
        ClassNameExists: "Class Name already exists",
        UserId: "User Id",
        IpAddress: "Ip Address",
        ClientAppId: "Client App Id",
        ActionType: "Action Type",
        EntityType: "Entity Type",
        SourceSystem: "Source System",
        AuditActionOtpEmailSent: "OTP Sent (Email)",
        AuditActionOtpSmsSent: "OTP Sent (SMS)",
        AuditActionOtpEmailCcSent: "OTP Sent (Email CC)",
        AuditSourceNotifications: "Notifications",
        Reason: "Reason",
        ClassName: "Class Name",
        CorrelationId: "Correlation Id",
        Timestamp: "Timestamp",
        CurrentStage: 'Current Stage',
        Changes: "Changes",
        ErrorMessage: "Error Message",
        OldValue: "Old value",
        NewValue: "New value",
        AuditLogsList: "Audit Logs List",
        AuditLogDetails: "Audit Log Details",
        LogId: "Log id: {{id}}",
        DateFrom: "Date From",
        DateTo: "Date To",
        LatestLogs: "LatestLogs",
        SeeMore: "See more",
        ServiceDetails: "Service Details",
        Code: "Code",
        TransactionName: "Transaction Name",
        ServiceSecurityImplicitType: "Service Security Implicit Type",
        ApprovedDelegation: "Approved Delegation",
        ApprovedProfile: "Approved Profile",
        CanBeDelegatedToAgent: "Can Be Delegated To Agent",
        ClientAgentCanSendSubmission: "Client Agent Can Send Submission",
        DelegationExpiresDays: "Delegation Expires Days",
        EnrollementAllowed: "Enrollement Allowed",
        IsVisible: "Is Visible",
        MultipleEnrollementsAllowed: "Multiple Enrollements Allowed",
        ProfileType: "Profile Type",
        RequireAuthentication: "Require Authentication",
        SubmissionAllowed: "Submission Allowed",
        WillBeActivatedAfterEnrollment: "Will Be Activated After Enrollment",
        AuditLogs: "Audit Logs",
        Id: "Id",
        ItemDeletionConfirmation: "Are you sure you want to delete this item with Name '{{selectedName}}'?",
        InstitutionDeletionConfirmation: "Are you sure you want to delete the institution '{{selectedName}}'? All of its services, and all transactions belonging to those services, will also be deleted.",
        ServiceDeletionConfirmation: "Are you sure you want to delete the service '{{selectedName}}'? All transactions belonging to this service will also be deleted.",
        SelectTransactionRoutesForRestoration: "Select transaction routes to restore with the service",
        BreadcrumbServiceTransationRoutes: "{{ serviceName }}: Transaction Routes",
        BreadcrumbRouteLabelTransactionParameters: "{{ routeLabel }}: Transaction Parameters",
        TransactionParameterDetails: "Transaction Parameter Details",
        ParameterType: "Parameter Type",
        ParameterName: "Parameter Name",
        ParameterValue: "Parameter Value",
        ParameterValueType: "Parameter Value Type",
        EditTransactionParameter: "Edit Transaction Parameter",
        CreateTransactionParameter: "Create Transaction Parameter",
        TransactionParametersList: "Transaction Parameters List",
        CopyParameters: "Copy Parameters",
        SelectOption: "Select option",
        SelectTransactionRoutesToCopyParameters: "Select the transaction route from which to copy parameters.",
        BackToTransactionRoutesList: "Back To Transaction Routes List",
        BackToServicesList: "Back to Services List",
        Location: "Location",
        AccessTokenUrl: "Access Token Url",
        ServiceConsumingType: "Service Consuming Type",
        TransactionMethod: "Transaction Method",
        AuthenticationType: "Authentication Type",
        RequestPayloadType: "Request Payload Type",
        RetryInterval: "Retry Interval",
        OperationType: "Operation Type",
        Enabled: "Enabled",
        Disabled: "Disabled",
        Yes: "Yes",
        No: "No",
        SpokeSubmissionOnly: "Spoke submission only (billable)",
        SpokeSubmissionOnlyHelp: "When checked, this transaction can be consumed only through the spoke submission service and every call is metered for billing. All other submit endpoints will refuse it.",
        TransationRouteDetails: "Transation Route Details",
        PostLocation: "Post Location",
        Approve: "Approve",
        ItemApproveConfirmation: "Are you sure you want to approve this item with Name '{{selectedName}}'?",
        TransactionRouteList: "Transaction Route List",
        RouteLabel: "Route Label",
        Institutions: "Institutions",
        InstitutionList: "Institution List",
        InstitutionDetails: "Institution Details",
        InstitutionDetailsWithName: "{{institutionName}} Institution Details",
        DataDifferences: "Data Differences",
        Transations: "Transations",
        Restore: "Restore",
        Parameters: "Parameters",
        ClaimLogicBuilder: "Claim Logic Builder",
        ServiceRestoredSuccessfully: "Service Restored Successfully",
        EditService: "Edit Service",
        CreateService: "Create Service",
        Institution: "Institution",
        Attribute: "Attribute",
        Enrollement: "Enrollement",
        Delegation: "Delegation",
        ServiceDeletedSuccessfully: "Service Deleted Successfully",
        ServiceCreatedSuccessfully: "Service Created Successfully",
        ServiceUpdatedSuccessfully: "Service Updated Successfully",
        InstitutionUpdatedSuccessfully: "Institution Updated Successfully",
        InstitutionCreatedSuccessfully: "Institution Created Successfully",
        InstitutionDeletedSuccessfully: "Institution Deleted Successfully",
        TransactionRouteUpdatedSuccessfully: "Transaction Route Updated Successfully",
        TransactionRouteCreatedSuccessfully: "Transaction Route Created Successfully",
        TransactionRouteDeletedSuccessfully: "Transaction Route Deleted Successfully",
        TransactionRouteApprovedSuccessfully: "Transaction Route Approved Successfully",
        TransactionParameterUpdatedSuccessfully: "Transaction Parameter Updated Successfully",
        TransactionParameterCreatedSuccessfully: "Transaction Parameter Created Successfully",
        TransactionParameterDeletedSuccessfully: "Transaction Parameter Deleted Successfully",
        TransactionParametersClonedSuccessfully: "Transaction Parameters Cloned Successfully",
        Required: "Required",
        PleaseSubmitAValue: "Please submit a value",
        DelegationExpiresDaysGEZero: "Delegation Expires Days must be greater than or equal to 0",
        PleaseSubmitInstitution: "Please submit an institution",
        EditTransactionRoute: "Edit Transaction Route",
        CreateTransactionRoute: "Create Transaction Route",
        AuditLogList: "Audit Log List",
        EditInstitution: "Edit Institution",
        CreateInstitution: "Create Institution",
        CopyTransactionParameters: "Copy Transaction Parameters",
        RouteName: "Route Name",
        SubmitAndCloseModal: "Submit and close modal ({{selectedCount}} selected)",
        Copy: "Copy",
        InstitutionIsNotEmpty: "The institution cannot be deleted, at least one service has been connected with the institution.",
        Claims: "Claims",
        PredefinedTemplateClaims: "Predefined template claims",
        SwitchToMultiClaimMode: "Switch to Multi-Claim Mode",
        SwitchToSingleClaimMode: "Switch to Single-Claim Mode",
        ResetBuilder: "Reset Builder",
        Preview: "Preview",
        JSONPreview: "JSON Preview",
        LogicType: "Logic Type",
        NegateCondition: "Negate this condition (NOT)",
        Claim: "Claim",
        Group: "Group",
        RemoveGroup: "Remove Group",
        SetCustomValue: "Set custom value",
        Remove: "Remove",
        ClaimSearchFailed: "Claim search failed: {{error}}",
        CanOnlySwitchToASingleClaim: "Can only switch to a single claim if exactly one child exists.",
        SelectPredefinedTemplateClaim: "Select Predefined template claim",
        PredefinedTemplateClaimsFailed: "Predefined template claims failed: {{error}}",
        ErrorGettingTemplateClaimAndLogic: "Error in getting the Predefined template claim and logic: {{error}}",
        ErrorGettingAllClaims: "Error in getting all claims: {{error}}",
        MustUsedWithinToastProvider: "useToast must be used within ToastProvider",
        PleaseFixValidationErrors: "Please fix the validation errors before proceeding.",
        DeleteItem: "Are you sure you want to delete this item?",
        ClaimLogicAddSuccess: "Claim logic created successfully for transaction route: {{transactionLabel}}!",
        ClaimLogicDeleteSuccess: "Claim logic deleted successfully for transaction route: {{transactionLabel}}!",
        SyncInAWAndSAAddSuccess: "The sync in Admin Web and Service Aggregator databases was created successfully!",
        SyncInAWAndSAAddFail: "The sync in Admin Web and Service Aggregator databases was failed!",
        Type: "Type",
        Value: "Value",
        Scope: "Scope",
        ClaimDataDifferences: "Claim Data Differences",
        SyncWithDatabase: "Are you sure you want to sync these data in the database?",
        SyncInDatabases: "Sync in databases",
        NoDataDifferencesFoundBetweenAWAndKeycloak: "No data differences found between Admin Web and Keycloak.",
        RefreshError: "Refresh error",
        FailedToRefresh: "Failed to refresh",
        Table: "table",
        ServiceDataDifferences: "Service Data Differences",
        ServicesDataDifferences: "Services Data Differences",
        RecordsFromDatabases: "Records from databases Admin Web, Service Aggregator and Transformations",
        ServiceID: "Service ID",
        ServiceId: "Service ID",
        Source: "Source",
        SyncIn: "Sync in {{database}}",
        Database: "Database",
        NoDataDifferencesFoundBetweenAWAndDatabases: "No data differences found between Admin Web, Service Aggregator and Transformations.",
        TransactionRoutesDataDifference: "Transaction Routes Data Difference",
        TransactionRoutesDataDifferences: "Transaction Routes Data Differences",
        TransactionsRouteID: "Transactions Route ID",
        TransactionParameters: "Transaction Parameters",
        TransactionParametersDataDifference: "Transaction Parameters Data Difference",
        TransactionParametersDataDifferences: "Transaction Parameters Data Differences",
        DatabaseTableRefreshed: "{{database}} table refreshed!",
        SyncInDatabaseAddSuccess: "The sync in {{database}} database was created successfully!",
        SyncInDatabaseAddFail: "The sync in {{database}} database was failed!",
        SyncServiceInDatabaseAddSuccess: "The service in {{database}} is created successfully!",
        SyncTransactionInDatabaseAddSuccess: "The transaction route in {{database}} is created successfully!",
        DeleteItemWithName: "Are you sure you want to delete this item with Name '{{name}}'?",
        PredefinedTemplateClaimUpdateSuccess: "Predefined template claim updated successfully!",
        PredefinedTemplateClaimAddSuccess: "Predefined template claim created successfully!",
        PredefinedTemplateClaim: "Predefined template claim",
        FieldRequired: "{{field}} is required",
        OneClaimRequiredInSingleClaimMode: "Exactly one Claim is required in Single-Claim mode",
        PleaseSelectClaim: "Please select claim...",
        CallbackError: "Callback error: {{error}}",
        UnauthorizedAccess: "Unauthorized Access",
        AccessDeniedText: "Access is denied <br/> You do not have permission to this page. <br/> Please contact with the administrator.",
        PageNotFound: "Page Not Found",
        PageNotFoundText: "The page you looked not found! <br/> Plan your blog post by choosing a topic.",
        SystemError: "System Error",
        SystemErrorText: "Something went wrong! <br/> Please try again later.",
        SetClaimValue: "Set claim value",
        MissingRoleForTransactionApprove: "Action restricted. Your role cannot approve transactions",
        GatewayLogs: "Gateway Logs",
        GatewayLogList: "Gateway Log List",
        LogMessage: "Log Message",
        LogType: "Log Type",
        AuditLevel: "Audit Level",
        TraceEventType: "Trace Event Type",
        CreatedAt: "Created At",
        GatewayLogDetails: "Gateway Log Details",
        ItemRestoreConfirmation: "Are you sure you want to restore this item with Name '{{selectedName}}'?",
        InstitutionRestoredSuccessfully: "Institution Restored Successfully",
        ShowDeleted: "Show Deleted",
        Individual: "Individual",
        Organisation: "Organisation",
        Agent: "Agent",
        Spoke: "Spoke",
        EmptyClaim: "[Empty Claim]",
        ErrorGettingProfileTypeClaim: "Error in getting the profile type claim: {{error}}",
        NotExistsProfileTypeClaimOrSync: "No profiletype claim exists in the database. Please verify that claims have been synchronized correctly from Keycloak.",
        PleaseSelectAtLeastOneProfileType: "Please select at least one Profile Type",
        RootNodeFailSave: "Transaction route was created successfully but the Claim logic is not saved",
        RootNodeIsNull: "Transaction route was created successfully but the Claim logic cannot be created",
        RemoveRoοt: "Remove Roοt",
        AddRoοt: "Add Roοt",
        CannotRemoveRoot: "You cannot remove the root, there is only one child",
        MissingRequiredFields: "There are missing required fields",
        LibraryPathAlreadyExists: "Library path already exists.",
        ClassNames: "Class Names",
        HardDelete: "Hard Delete",
        MissingRoleForTransactionHardDelete: "Although the Transaction Route is approved, your role cannot perform a hard delete.",
        ItemHardDeletionConfirmation: "Are you sure you want to hard delete this item with Name '{{selectedName}}'?",
        TransactionRouteRestoredSuccessfully: "The Transaction Route, along with any associated Transaction Parameters, has been successfully restored!",
        TransactionRouteHardDeletedSuccessfully: "The Transaction Route, along with any associated Transaction Parameters, has been successfully deleted!",
        ForbidActionForTransactionApprove: "This Transaction Route is currently in a soft-deleted state and cannot be approved before it is restored.",
        ForbidApprovalActionForTransactionBeforeServiceRestored: "The Service of this Transaction Route is currently in a soft-deleted state. Approval action cannot be performed until the Service is restored.",
        ForbidActionsForTransactionsBeforeServiceRestored: "The Service of these Transaction Routes is currently in a soft-deleted state. Approval or restoration actions cannot be performed until the Service is restored.",
        ForbidRestoreActionForTransactionBeforeServiceRestored: "The Service of this Transaction Route is currently in a soft-deleted state. Restoration action cannot be performed until the Service is restored.",
        ForbidCreateActionForTransaction: "The Service is currently in a soft-deleted state. You cannot create a Transaction Route until the Service is restored.",
        ForbidCreateActionForTransactionParams: "The Service/Transaction Route is currently in a soft-deleted state. You cannot create a Transaction Parameter until the Service/Transaction Route is restored.",
        ForbidCopyParamsActionForTransactionParams: "The Service/Transaction Route is currently in a soft-deleted state. You cannot copy Transaction Parameter(s) until the Service/Transaction Route is restored.",
        ForbidSyncActionForTransactionBeforeServiceTransactionRestored: "The Service/Transaction Route is currently in a soft-deleted state. Synchronization cannot proceed until the Service/Transaction Route is restored.",
        UserName: "User Name",
        UserRemoved: "User removed",
        FullName: "Full Name",
        UpdateLibrary: "Update Library",
        EditLibrary: "Edit Library",
        LibraryPathNotExists: "The library was successfully deleted, but the path is undefined.",
        LibraryDirectoryNotExists: "The library was successfully deleted, though its directory no longer exists.",
        DeleteWarningWithStatus: "The library was successfully deleted, but completed with warnings (Status: {{status}}, Message: '{{data}}').",
        ForbidViewActionForLogs: "You don’t have the necessary permissions to view the logs.",
        All: "All",
        ClientId: "SSO Client ID",
        Total: "Total",
        Clients: "SSO Clients",
        LoginTypes: {
            citizen: "Citizen",
            business: "Business",
            ["entra-id"]: "Entra ID",
            certificate: "Certificate",
            ["admin-module"]: "Administration module"
        },
        SearchBy: "Search by",
        SearchByTooltip: "Choose where the search should match: Name, Client App Id, or both.",
        ClientUpdatedSuccessfully: "SSO Client Updated Successfully",
        ItemsPerPage: "Items per page",
        Filters: "Filters",
        PredefinedTemplateClaimList: "Predefined template claim List",
        Refresh: "Refresh",
        ChooseDate: "Choose a date",
        Time: "Time",
        FindProfiles: "Find Profiles",
        SelectAtLeastOneFilter: "Please select at least one filter",
        SetFiltersAndSearch: "Please set filters above and click Search to load results.",
        ProfileState: "Profile State",
        Approved: "Approved",
        ViewEvents: "View Events",
        NoDataFound: "No profiles found matching the criteria.",
        ChooseADate: "Choose a date",
        DateRangeInvalid: "End date must be the same or after start date",
        ActionTypes: "Action Types",
        UserChanges: "User changes",
        EventsOfProfileLabel: "Events of profile:",
        ProfileEvents: "Profile Events",
        MobileNumber: "Mobile Number",
        Email: "Email",
        FirstName: "First Name",
        LastName: "Last Name",
        UserProfilesList: "User Profiles List",
        NoEventsDataFound: "No events found matching the criteria.",
        Exact: "Exact",
        SaveChanges: "Save Changes",
        ConfirmChanges: "Confirm Changes",
        AboutToUpdateClients: "You are about to update {{count}} client(s):",
        RemoveFromBatch: "Remove from batch",
        ConfirmAndSave: "Confirm and Save",
        ClientsUpdatedSuccessfully: "{{count}} client(s) updated successfully",
        SomeUpdatesFailed: "{{count}} update(s) failed",
        DeselectAll: "Deselect all",
        SelectAll: "Select all",
        ProfileDetails: "Profile Details",
        ProfileId: "Profile Id",
        Description: "Description",
        LanguageCode: "Language Code",
        UnmanagedClaims: "Unmanaged Claims",
        IsMainUser: "Main User",
        Category: "Category",
        CreatedBy: "Created By",
        IdpRealm: "Idp Realm",
        Roles: "Roles",
        UserType: "User Type",
        DeleteUser: "Delete User",
        EditProfile: "Edit Profile",
        ConfirmDeletion: "Confirm Deletion",
        SureToDeleteUser: "Are you sure you want to delete this user?",
        UserDeleteSuccess: "User was deleted successfully!",
        ActionIrreversible: "This action is irreversible",
        DisableProfile: "Disable Profile",
        DisablingPrevents:"Disabling this profile will prevent authentication and service usage",
        Disabling: "Disabling",
        ProfileDisabledSuccessfully: "Profile Disabled Successfully",
        UndoDisable: "This action can be reverted by reactivating the profile",
        Activating: "Activating",
        ActivateProfile: "Activate Profile",
        ActivatingRestores: "Activating this profile will restore authentication and service access",
        ProfileActivatedSuccessfully: "Profile Activated Successfully",
        ProfileUpdatedSuccessfully: "Profile Updated Successfully",
        ClaimUpdatedSuccessfully: "Claim Updated Successfully",
        UpdateClaim: "Update Claim",
        ProfileIsApproved: "Profile Is Approved",
        ProfileApprovedSuccessfully: "Profile Approved Successfully",
        ResetPass: "Reset Password",
        TemporaryPassword: "Temporary Password",
        ViewProfileClaims: "View Profile Claims",
        CharCount: "8-12 characters",
        UppercaseLowercase: "Must contain both uppercase and lowercase letters",
        AtLeastOneNumber: "Must contain at least one number",
        NoWordPassword: "Must not contain the word password",
        ProfileRequiredActions: "Profile Required Actions",
        ApproveProfile: "Approve Profile",
        FailedToGetActionLink: "Failed to get action link",
        FailedToGenerateActionLink: "Failed to generate action link",
        GeneratedLink: "Generated Link",
        CopyLink: "Copy Link",
        OpenNewTab: "Open in a new tab",
        TestLink: "For testing, open this link in an incognito/private window to avoid session conflicts.",
        Copied: "Copied",
        UpdatePassword: "Update Password",
        ConfigureOTP: "Configure OTP",
        VerifyEmail: "Verify Email",
        UnlockUser: "Unlock User",
        ApprovingWillUnlockUser: "Approving will unlock the locked user",
        Approving: "Approving",
        Confirm: "Confirm",
        GetActionLinks:"Get Action Links",
        UserAlreadyVerified: "User is already verified",
        LinkSentSuccessfully: "Link was sent successfully!",
        ResendActivationLink: "Resend activation link",
        EmailOnly: "Email Only",
        SmsOnly: "Sms Only",
        EmailAndSms: "Email and Sms",
        ResendLink: "Resend link",
        InvalidProfile: "Invalid Profile",
        ResetPasswordSmsSent: "Reset Password Sms Sent",
        ResetPasswordSmsFailed: "Reset Password Sms Failed",
        SendResetPasswordSms: "Send Reset Password Sms",
        ResetPasswordSmsLink: "Reset Password Sms Link",
        ResetPassword: "Reset Password",
        ManageAccounts: "Manage Accounts",
        ApprovingWillActivate: "Are you sure you want to approve this account? ",
        CreateUser: "Create User",
        UserCreatedSuccessfully: "User Created Successfully",
        MobileNumberAlreadyInUse: "Mobile Number Already In Use",
        AgentUsersList: "Agent Users List",
        NewProfile: "New Profile",
        CreateAgentUser: "Create Agent User",
        CreateProfile: "Create Profile",
        ProfileUnlockedSuccessfully: "Profile Unlocked Successfully",
        ProfileNotFound: "Profile not found",
        OTPReset: "This will remove the current OTP configuration. The user will be required to scan a new QR code to regain access to their account on their next login.",
        ConfirmOtpUnassignment: "Confirm OTP Reset",
        ResetOTPApp: "Reset OTP App",
        UnassigningOtp: "Unassigning OTP App",
        ProfileActionsInfo: "Select from the available Required Actions below to update the user's security requirements. These settings will take effect the next time the user attempts to sign in to their account.",
        ConfirmOtpAssignment: "Confirm Otp Assignment",
        OTPAssignment: "This forces the user to configure a new authenticator app. They will see a QR code on their next login and must complete setup to proceed.",
        AssignOTPApp: "Assign OTP App",
        AssigningOTP: "Assigning OTP App",
        OtpAssignedSuccessfully: "OTP App assigned successfully",
        OtpUnassignedSuccessfully: "OTP app reset successfully",
        PassReset: "This action emails a new random password to the user. Their current password will be invalidated, and a reset will be required at next sign-in.",
        GeneratePass: "Generate Temporary Password",
        SendResetPassSMSInfo: "This will generate a random, temporary password and send it to the user's registered mobile number.The user's current password will be cleared, and they must set a new one upon their next sign-in.",
        ViewProfileDetails: "View Profile Details",
        ActionLinks: "Generate secure, one-time URLs for users to verify their email, reset passwords, or configure OTP. Copy these to send directly to the user.",
        ViewRoles: "View Roles",
        UserRoles: "User Roles",
        LinkAlreadySent: "Link Already Sent",
        RolesUpdatedSuccessfully: "Roles Updated Successfully",
        SomethingWentWrong: "Something Went Wrong",
        SystemIdentifiers: " System Identifiers",
        AllowedTransactions: "Allowed Transactions",
        AllowedTransactionsHint: "When empty, this spoke can submit to any transaction. When populated, only the selected ones are accepted.",
        AllowedTransactionsNoneConfigured: "No restriction — this spoke can submit to any transaction.",
        AllowedTransactionsUnknown: "unknown",
        AllowedTransactionsSelectedCount: "{{count}} selected",
        AllowedClassesUpdatedSuccessfully: "Allowed transactions updated successfully.",
        NoResults: "No results",
        ClearGroup: "Clear",
        AllowedTransactionsManage: "Manage Allowed Transactions",
        AllowedTransactionsStatusUnrestricted: "Unrestricted — submits to any transaction",
        AllowedTransactionsStatusRestricted: "Restricted to {{count}} transactions across {{services}} services",
        AllowedTransactionsStatusOrphanCount: "{{count}} unknown",
        OtpMethod: "OTP Method",
        NoProfileIdProvided: "No ProfileId Provided",
        UpdateName: "Update Name",
        Updating: "Updating...",
        FullNameUpdatedSuccessfully: "Full name has been updated successfully.",
        ErrorUpdatingName: "An error occurred while trying to update the name.",
        HelpDeskOperatorDescription: "Can search, view and assist user profiles. Limited administrative rights.",
        ManageProfileDescription: "Can update, activate, disable and manage user accounts.",
        Assign: "Assign",
        Role: "Role",
        ManageProfile: "Profile Manager",
        HelpDeskOperator:  "HelpDesk Operator",
        Temporarypasswordwasresetsuccessfully: "Temporary password was reset successfully",
        TransactionsApprove: "Transactions Approver",
        AuditLogsViewer: "Audit Logs Viewer",
        GatewayLogsViewer: "Gateway Logs Viewer",
        SSOClients: "SSO Client Management",
        ManageServices: "Services Management",
        ManageInstitutions: "Institutions Management",
        ClaimsViewer: "Claims Viewer",
        ManageTemplateClaims: "Template Claims Management",
        TransactionsApproveDescription: "Can approve a transaction only once.",
        AuditLogsViewerDescription: "Can view the latest logs on the Home page, all logs in Audit Logs, and details of individual logs.",
        GatewayLogsViewerDescription:"Can view Gateway Logs and the details of individual gateway logs.",
        ClientsDescription: "Can enable or disable login options per client. Supports individual or batch updates.",
        ManageServicesDescription: "Can manage the Services menu.",
        ManageInstitutionsDescription: "Can manage the Institutions menu.",
        ClaimsViewerDescription: "Can view Claims details.",
        ManageTemplateClaimsDescription: "Can create, edit, and delete predefined claim templates.",
        Use: "Use",
        EmailAlreadyInUse: "Email Already In Use",
        UsernameAlreadyInUse: "Username Already In Use",
        InvalidMobileFormat:"Invalid Mobile Format",
        InvalidEmailFormat: "Invalid Email Format",
        FieldIsRequired: "Field Is Required",
        CorrelationIdInvalidFormat: "Please enter the Correlation ID in the correct format",
        IdInvalidFormat: "Please enter the ID in the correct format",
        ChangedBy: "Changed By",
        SendResetPassSmsInfo: "Sends a reset password SMS to the user with a secure link. The user can use this link to set a new password.",
        RoleChanges: "Role Changes",
        ClearMobileNumber: "Remove phone number",
        MobileNumberWillBeCleared: "The phone number will be removed when you save.",
        WillBeCleared: "Will be removed",
        ProfileEventsHistory: "Profile Events History",
        AdminProfileId: "Admin Profile ID",
        ManageRoles: "Roles Manager",
        ManageRolesDescription: "Can create Helpdesk users and manage their roles.",
        EmailVerifiedSuccessfully: "Email verified successfully!",
        VerifyEmailConfirmation: "Are you sure you want to verify the email for this user?",
        Verifying: "Verifying...",

        TransactionExplorer: "Transaction Explorer",
        Transaction: "Transaction",
        Endpoint: "Endpoint",
        Successful: "Successful",
        Failed: "Failed",
        LastExecuted: "Last Executed",
        LastNDays: "Last {{count}} days",
        AllTime: "All time",
        Window: "Window",
        TransactionStatistics: "Transaction statistics",
        RecentExecutions: "Recent Executions",
        ExecutionDetails: "Execution Details",
        NoParameters: "No parameters",
        Request: "Request",
        Response: "Response",
        RequestResponseTemplate: "Request / Response Template",
        NoPayload: "No payload available",
        Compare: "Compare",
        ShowOnlyDifferences: "Show only differences",
        NoDifferences: "No differences",
        DifferencesCount: "{{count}} difference(s)",
        Status: "Status",
        Success: "Success",
        Caller: "Caller",
        Duration: "Duration",
        StartedAt: "Started At",
        Impersonator: "Impersonator",
        SelectExecutionHint: "Select an execution to view its parameters and payloads.",
        SeenTimes: "Seen {{count}} time(s) in the window",
        TemplateRank: "Rank {{rank}}",
        TemplateVariant: "Template variant",
        Pin: "Pin",
        Unpin: "Unpin",
        Pinned: "Pinned",
        PinTemplateHint: "Pinned templates are kept by the scheduled job even if they fall out of the top shapes.",
        TemplatePinned: "Template pinned — it will be kept on future refreshes.",
        TemplateUnpinned: "Template unpinned — it may be replaced on the next refresh.",
        AddTemplate: "Add template",
        CleanAndAdd: "Clean & add",
        AddTemplateHint: "Paste a {{direction}} (XML or JSON). It will be cleaned the same way as auto-generated templates (values blanked) and pinned so it is kept.",
        Manual: "Manual",
        TemplateAdded: "Template added, cleaned and pinned.",
        TemplatePayloadInvalid: "Paste a valid XML or JSON payload (it must start with <, { or [).",
        NoTemplateAvailable: "No template available yet",
        CompareWithTemplate: "Compare with template",
        LoadFromExecution: "Load from selected execution",
        PastePayloadLabel: "Paste a request or response to compare it against the template",
        PastePayloadPlaceholder: "Paste XML or JSON here…",
        YourPayload: "Your payload",
        PasteToCompare: "Paste a payload above to compare it with the template.",
        Clear: "Clear",
        StructureCheck: "Structure check",
        StructureMatches: "The payload matches the template structure.",
        MissingTags: "Missing (in template, not in payload)",
        ExtraTags: "Extra (in payload, not in template)",
        EmptyValues: "Empty values (present but blank)",
        FormatDiffers: "Payload format differs from the template — showing text diff only.",
        Find: "Find",
        FindByCorrelationId: "Find by Correlation ID",
        TransactionNotFound: "Transaction not found",

        ConsumptionLogs: "API Consumption Logs",
        ConsumptionLogList: "API Consumption Logs",
        ConsumptionLogDetails: "Consumption Log Details",
        ConsumptionReports: "API Consumption Reports",
        SpokeUserId: "Consumer User Id",
        SpokeName: "Consumer",
        DownloadPdf: "Download PDF",
        GeneratedAt: "Generated",
        GeneratedBy: "by",
        Metric: "Metric",
        Month: "Month",
        ChooseMonth: "Choose month",
        Errors: "Errors",
        CallsThisPeriod: "Calls This Period",
        SearchClass: "Type to search classes...",
        AddClass: "Add",
        ReportIntro: "This report presents the transaction consumption data",
        ForUser: "for user",
        ForTransactions: "for services",
        WithTransactions: "regarding services",
        InPeriod: "in period",
        DuringPeriod: "for the period",
        Period: "Period",
        MonthsShort: "Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec",
        ConsentId: "Consent Id",
        SubjectId: "Subject Id (NID/NIPT)",
        BackendStatusCode: "Backend Status Code",
        GatewayStatusCode: "Gateway Status Code",
        ErrorCode: "Error Code",
        ErrorText: "Error Text",
        ResponseTimeMs: "Response Time (ms)",
        RequestTimestamp: "Request Timestamp",
        ResponseTimestamp: "Response Timestamp",
        CallerIp: "Caller IP",
        TotalCalls: "Total Calls",
        SuccessfulCalls: "Successful (2xx)",
        ClientErrorCalls: "Client Error (4xx)",
        ServerErrorCalls: "Server Error (5xx)",
        AvgResponseMs: "Avg Response (ms)",
        P95ResponseMs: "P95 Response (ms)",
        CallsToday: "Calls Today",
        CallsYesterday: "Calls Yesterday",
        CallsOn: "Calls on",
        AvgResponseMsYesterday: "Avg Response Yesterday (ms)",
        AvgResponseMsOn: "Avg Response on",
        CallsThisMonth: "Calls This Month",
        SuccessRate: "Success Rate",
        AvgResponseMsToday: "Avg Response Today (ms)",
        TopSpokes: "Top Consumers",
        TopClasses: "Top Transactions",
        PerSpokeReport: "Per Consumer / Transaction",
        PerServiceReport: "Per Transaction",

        Statistics: "Statistics",
        NewUsersStatistics: "New Users",
        TransactionConsumptionStatistics: "Transaction Consumption",
        TransactionConsumptionStatisticsHint: "Nr. of Transactions affects both Average Transaction Time and P2G/G2G Transactions. Transaction Name only affects Average Transaction Time.",
        TargetProfileId: "Profile Id",
        TrxName: "Transaction Name",
        NrTrx: "Nr. of Transactions",
        NrTrxPlaceholder: "Leave blank to include all",
        NrTrxTooLow: "Value must be a whole number greater than or equal to {{min}}.",
        AverageTrxTimeNote: "Limited to the first {{count}} transactions",
        AverageTrxTimeNoteUnlimited: "Includes all transactions in the selected period",
        StatisticsDateRangeRequired: "Please fill out at least the start date and end date before searching.",
        TotalUsers: "Total Users",
        NewUsersRatio: "New Users Ratio",
        AverageTrxTime: "Average Transaction Time",
        P2GTransactions: "P2G Transactions",
        G2GTransactions: "G2G Transactions",
        TotalTransactions: "Total Transactions",
        NrOfTrxForUser: "Transactions for Profile",
        NrOfLoginsForUser: "Logins for Profile",
        UserCountByProfileType: "Users by Profile Type",
        NoData: "No data",
        StatisticsProfileNotFound: "No profile found matching id '{{profileId}}'.",

    }
};

export default en;
